<div class="modal-header">
  <h5 class="modal-title text-capitalize" id="exampleModalLabel">
    <i class="fas fa-bell"></i> &nbsp;{{'ClientsNotifications' | translate}}
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" [dir]="sharedService.Lang == 'ar' ? 'rtl' : 'ltr'">
  <div class="row" id="printClientNotification">
    <div class="col-md-12">
      <div class="row">
        <div class="col-lg-12" *ngIf="Form">
          <div class="formCard">

            <div class="row">
              <div class="col-lg-12 text-center lableClass"
                *ngIf="CurrentTransactionOTPType == transactionOTPType.PayBookingAndChangeStatus">
                {{ 'PleaseSendOTPToClientToLetHimConfirmBookingPaymentOrChangeStatus' | translate }}
              </div>
              <div class="col-lg-12 text-center lableClass"
                *ngIf="CurrentTransactionOTPType == transactionOTPType.BillDiscount">
                {{ 'PleaseSendOTPToClientToLetHimConfirmBillDiscount' | translate }}
              </div>
            </div>

            <div class="row">
              <div class="col-lg-8">
                <div class="form-group">
                  <label>{{ 'EnterOTPHere' | translate }}</label>
                  <input [(ngModel)]="OTPCode" type="text" class="form-control"
                    [disabled]="!transactionOTPResponse?.ClientNotificationOTPId"
                    [placeholder]="transactionOTPResponse?.ClientNotificationOTPId ? ('EnterOTPHere' | translate) : ('YouMustSendOTPFirst' | translate)">
                </div>
              </div>
              <div class="col-lg-4">
                <button class=" btn btn my-0 px-3 sendOTPClass" [disabled]="loading || (seconds60 && seconds60 > 0)"
                  (click)="SendOTP()">
                  <i class="fas fa-send-o"></i> &nbsp;
                  {{'SendOTP' | translate}}
                </button>
              </div>

            </div>

            <div class="row">
              <div class="col-lg-12 warning" [hidden]="!seconds60 || seconds60 <= 0">
                <span> {{ 'YouCanSendCodeAgainWithin' | translate }}</span> &nbsp;
                <span #seconds></span> <span> {{ 'Seconds' | translate }} </span>
              </div>
            </div>
          </div>
          <div class="col-lg-12" *ngIf="!Form">
            <div class="col-md-12 text-center py-4 my-4">
              <i class="fas fa-circle-notch fa-spin fa-3x"></i>
              <h1>{{'Loading' | translate}} </h1>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-modal-action" (click)="activeModal.close('Close click')">{{ 'Confirm' | translate
    }}</button>
</div>
